module.exports = "/assets/e6665b9ad436506737f5dbf6fcd346b8.svg";